var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "app-main-inner recon-task-detail"
    },
    [
      _vm.errorMessage
        ? _c("el-alert", {
            staticClass: "recon-task-detail__alert",
            attrs: {
              title: _vm.errorMessage,
              type: "error",
              "show-icon": "",
              closable: false
            }
          })
        : _vm.detail.taskUuid
        ? [
            _c("div", { staticClass: "section detail-toolbar" }, [
              _c("div", { staticClass: "detail-toolbar__title" }, [
                _c("i", { staticClass: "el-icon-document-checked" }),
                _c("span", [_vm._v("对账任务详情")])
              ]),
              _c(
                "div",
                { staticClass: "detail-toolbar__actions" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", icon: "el-icon-refresh" },
                      on: { click: _vm.fetchDetail }
                    },
                    [_vm._v("刷新")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        size: "mini",
                        icon: "el-icon-download",
                        disabled: !_vm.detail.originalFileId
                      },
                      on: { click: _vm.downloadOriginalFile }
                    },
                    [_vm._v(" 下载原始账单 ")]
                  ),
                  _vm.canReparse
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            size: "mini",
                            type: "primary",
                            icon: "el-icon-refresh-right"
                          },
                          on: { click: _vm.handleReparse }
                        },
                        [_vm._v(" 重新解析 ")]
                      )
                    : _vm._e(),
                  _vm.showCompleteAction
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            size: "mini",
                            type: "success",
                            icon: "el-icon-circle-check",
                            disabled: !_vm.canComplete
                          },
                          on: { click: _vm.handleComplete }
                        },
                        [_vm._v(" 对账完成 ")]
                      )
                    : _vm._e()
                ],
                1
              )
            ]),
            _c("div", { staticClass: "section task-summary" }, [
              _c("div", { staticClass: "task-summary__top" }, [
                _c("div", [
                  _c(
                    "div",
                    { staticClass: "task-summary__identity" },
                    [
                      _c("span", { staticClass: "task-summary__number" }, [
                        _vm._v(_vm._s(_vm.detail.taskNo || "-"))
                      ]),
                      _c(
                        "el-tag",
                        {
                          attrs: {
                            type: _vm.statusMeta.type,
                            size: "mini",
                            effect: "plain"
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.statusMeta.label) + " ")]
                      )
                    ],
                    1
                  ),
                  _c("div", { staticClass: "task-summary__time" }, [
                    _vm._v("创建于 " + _vm._s(_vm.detail.createdTime || "-"))
                  ])
                ]),
                _c("div", { staticClass: "task-summary__amounts" }, [
                  _c("div", { staticClass: "amount-item" }, [
                    _c("span", { staticClass: "amount-item__label" }, [
                      _vm._v("人民币合计")
                    ]),
                    _c("strong", [
                      _vm._v(
                        _vm._s(_vm.formatAmount(_vm.detail.cnyTotal, "CNY"))
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "amount-item" }, [
                    _c("span", { staticClass: "amount-item__label" }, [
                      _vm._v("美元合计")
                    ]),
                    _c("strong", [
                      _vm._v(
                        _vm._s(_vm.formatAmount(_vm.detail.usdTotal, "USD"))
                      )
                    ])
                  ])
                ])
              ]),
              _c("div", { staticClass: "task-summary__grid" }, [
                _c("div", { staticClass: "summary-field" }, [
                  _c("span", [_vm._v("供应商")]),
                  _c("strong", [_vm._v(_vm._s(_vm.detail.supplierName || "-"))])
                ]),
                _c("div", { staticClass: "summary-field" }, [
                  _c("span", [_vm._v("账单类型")]),
                  _c("strong", [_vm._v(_vm._s(_vm.billTypeLabel))])
                ]),
                _c("div", { staticClass: "summary-field" }, [
                  _c("span", [_vm._v("账单周期")]),
                  _c("strong", [_vm._v(_vm._s(_vm.periodLabel))])
                ]),
                _c(
                  "div",
                  { staticClass: "summary-field" },
                  [
                    _c("span", [_vm._v("原始账单")]),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "text",
                          size: "mini",
                          disabled: !_vm.detail.originalFileId
                        },
                        on: { click: _vm.downloadOriginalFile }
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.detail.originalFileName || "-") + " "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _c("div", { staticClass: "summary-field" }, [
                  _c("span", [_vm._v("最近更新")]),
                  _c("strong", [_vm._v(_vm._s(_vm.detail.updatedTime || "-"))])
                ]),
                _c(
                  "div",
                  { staticClass: "summary-field summary-field--wide" },
                  [
                    _c("span", [_vm._v("备注")]),
                    _c("strong", [_vm._v(_vm._s(_vm.detail.remark || "无"))])
                  ]
                )
              ])
            ]),
            _c(
              "div",
              { staticClass: "section task-progress" },
              [
                _c("div", { staticClass: "section-title" }, [
                  _c("i", { staticClass: "el-icon-s-operation" }),
                  _c("span", [_vm._v("对账处理进度")])
                ]),
                _c(
                  "el-steps",
                  {
                    staticClass: "task-progress__steps",
                    attrs: {
                      active: _vm.activeStep,
                      "align-center": "",
                      "finish-status": "success",
                      "process-status": _vm.progressStatus
                    }
                  },
                  [
                    _c("el-step", {
                      attrs: {
                        title: "账单上传",
                        description: _vm.detail.createdTime || "已完成"
                      }
                    }),
                    _c(
                      "el-step",
                      { attrs: { description: _vm.parseStepDescription } },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "task-progress__step-title",
                            attrs: { slot: "title" },
                            slot: "title"
                          },
                          [
                            _c("span", [_vm._v("账单解析")]),
                            _vm.parseErrorMessage
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "task-progress__error-tip-wrap",
                                    attrs: {
                                      "data-tooltip": _vm.parseErrorMessage,
                                      "aria-label": _vm.parseErrorMessage,
                                      role: "img",
                                      tabindex: "0"
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "el-icon-question task-progress__error-tip"
                                    })
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      ]
                    ),
                    _c("el-step", {
                      attrs: {
                        title: "系统匹配",
                        description: _vm.matchStepDescription
                      }
                    }),
                    _c("el-step", {
                      attrs: {
                        title: "人工复核",
                        description: _vm.reviewStepDescription
                      }
                    }),
                    _c("el-step", {
                      attrs: {
                        title: "对账完成",
                        description: _vm.completeStepDescription
                      }
                    })
                  ],
                  1
                ),
                _vm.canRematch
                  ? _c("div", { staticClass: "task-progress__actions" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "task-progress__action task-progress__action--match"
                        },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "task-progress__rematch",
                              attrs: {
                                type: "text",
                                size: "mini",
                                icon: "el-icon-refresh-right",
                                loading: _vm.rematching
                              },
                              on: { click: _vm.handleRematch }
                            },
                            [_vm._v(" 重新匹配 ")]
                          )
                        ],
                        1
                      )
                    ])
                  : _vm._e()
              ],
              1
            ),
            _c("div", { staticClass: "metrics-grid" }, [
              _c(
                "div",
                { staticClass: "section metric-card metric-card--total" },
                [
                  _c("i", { staticClass: "el-icon-tickets metric-card__icon" }),
                  _c("div", [
                    _c("div", { staticClass: "metric-card__label" }, [
                      _vm._v("总费用条目")
                    ]),
                    _c("div", { staticClass: "metric-card__value" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.numberValue(_vm.detail.totalItemCount)) +
                          " "
                      ),
                      _c("span", [_vm._v("条")])
                    ])
                  ])
                ]
              ),
              _c(
                "div",
                { staticClass: "section metric-card metric-card--matched" },
                [
                  _c("i", {
                    staticClass: "el-icon-circle-check metric-card__icon"
                  }),
                  _c("div", [
                    _c("div", { staticClass: "metric-card__label" }, [
                      _vm._v("完全匹配")
                    ]),
                    _c("div", { staticClass: "metric-card__value" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.numberValue(_vm.detail.matchedCount)) +
                          " "
                      ),
                      _c("span", [_vm._v("条")])
                    ])
                  ])
                ]
              ),
              _c(
                "div",
                { staticClass: "section metric-card metric-card--exception" },
                [
                  _c("i", {
                    staticClass: "el-icon-warning-outline metric-card__icon"
                  }),
                  _c("div", [
                    _c("div", { staticClass: "metric-card__label" }, [
                      _vm._v("异常条目")
                    ]),
                    _c("div", { staticClass: "metric-card__value" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.numberValue(_vm.detail.exceptionCount)) +
                          " "
                      ),
                      _c("span", [_vm._v("条")])
                    ])
                  ])
                ]
              )
            ]),
            _c(
              "div",
              { staticClass: "section detail-entry" },
              [
                _c("div", [
                  _c("div", { staticClass: "detail-entry__title" }, [
                    _vm._v("费用同屏比对")
                  ]),
                  _c("div", { staticClass: "detail-entry__desc" }, [
                    _vm._v(
                      " 查看供应商账单与系统应付费用，处理差异、争议和人工接受。 "
                    )
                  ])
                ]),
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "primary",
                      size: "small",
                      icon: "el-icon-s-data",
                      disabled: !_vm.canOpenComparison
                    },
                    on: { click: _vm.openComparison }
                  },
                  [_vm._v(" 进入同屏比对详情 ")]
                )
              ],
              1
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }